import { FC, useEffect, useState, PropsWithChildren } from 'react'
import { Button, Radio, Dropdown, Spin, TriggerProps } from '@arco-design/web-react'
import _ from 'lodash'
import useLocale from '@/utils/useLocale'
import useGetCollectionStore from '@/pages/platform/favorites/hooks/useGetCollectionStore'
import { useSelector } from 'react-redux'
import type { StoreState } from '@/store'
import type { CollectionGroupRes } from '@/types/api'
import { moveGroupApi } from '@/api/favorites'
import styles from './index.module.less'
import { backendCodeProcessor } from '@/api/request'

type GroupSelectProps = {
  id: string
  groupId?: string
  type: keyof CollectionGroupRes
  onClose: () => void
  onMoved?: () => void
  triggerProps?: TriggerProps
}

const GroupSelect: FC<GroupSelectProps> = (props) => {
  const { id, groupId, type, onClose, onMoved } = props
  const { group } = useSelector((state: StoreState) => state.collection)
  const { getFetchCollection, loadingGetCollection } = useGetCollectionStore()
  const groupList = group[type]
  const [selected, setSelected] = useState(groupId || groupList[0]?.id)
  const t = useLocale()

  useEffect(() => {
    if (_.isEmpty(groupList)) {
      getFetchCollection()
    }
  }, [])

  return (
    <div className={styles.dropdownContent}>
      <div className={styles.title}>{t['favorite.move_group']}</div>

      <div className={styles.content}>
        {_.isEmpty(groupList) ? (
          <Spin loading={loadingGetCollection} style={{ width: '100%', margin: '3px 0', textAlign: 'center' }}></Spin>
        ) : (
          <Radio.Group
            direction="vertical"
            defaultValue={groupId || groupList[0].id}
            onChange={setSelected}
            className={styles.radioGroup}
          >
            {groupList
              .filter((item) => item.id !== '')
              .map((item) => {
                return (
                  <div className={styles.radioItem} key={item.id}>
                    <Radio value={item.id}>{item.name}</Radio>
                  </div>
                )
              })}
          </Radio.Group>
        )}
      </div>

      <div className={styles.actions}>
        <Button className={styles.cancelButton} onClick={onClose}>
          {t['modal.close']}
        </Button>
        <Button
          type="primary"
          className={styles.okButton}
          onClick={() => {
            onClose()
            moveGroupApi({ id, group_id: selected || groupList[0]?.id })
              .then(backendCodeProcessor)
              .then(() => {
                onMoved?.()
              })
          }}
        >
          {t['common.list.ok']}
        </Button>
      </div>
    </div>
  )
}

type Props = GroupSelectProps &
  PropsWithChildren<{
    popupVisible: boolean
  }>

const CollectGroupDropdown: FC<Props> = (props) => {
  const { popupVisible, triggerProps, ...restProps } = props

  return (
    <Dropdown
      popupVisible={popupVisible}
      position="br"
      triggerProps={{
        className: styles.popup,
        onClickOutside: props.onClose,
        ...triggerProps
      }}
      droplist={<GroupSelect {...restProps} />}
    >
      {props.children}
    </Dropdown>
  )
}

export default CollectGroupDropdown
